<template>
  <div class="p-4">
    <!-- <h1>Changelog</h1>
    <p class="text-small">
      <strong>Last App Update:</strong> {{ dateFormat(processEnv.VUE_APP_BUILD_TIME / 1000, true) }}
    </p>
    <div v-if="pendingChanges && pendingChanges.length">
      <h2>Pending Changes</h2>
      <p class="mb-0">
        Changes that are included in this build but are not yet tagged in an official version
      </p>
      <p class="small"><em>Versions are created before production deploys</em></p>
      <div>
        <ul>
          <template v-for="(change, c) in pendingChanges">
            <li :key="c">{{ change.message }} <span v-if="change.internal">(internal)</span></li>
          </template>
        </ul>
      </div>
    </div>
    <hr />
    <div v-for="(version, v) in parsedChangelog" :key="v">
      <h2>Version {{ version.semver }} <span v-if="v === 0">(Current)</span></h2>
      <div v-if="showList(version.features)">
        <p><strong>Features</strong></p>
        <ul>
          <template v-for="(change, c) in version.features">
            <li :key="c" v-if="!change.internal || isAdminOrBeta">
              {{ change.message }}
              <span v-if="change.internal">(internal)</span>
            </li>
          </template>
        </ul>
      </div>
      <div v-if="showList(version.removals)">
        <p><strong>Removals</strong></p>
        <ul>
          <template v-for="(change, c) in version.removals">
            <li :key="c" v-if="!change.internal || isAdminOrBeta">
              {{ change.message }}
              <span v-if="change.internal">(internal)</span>
            </li>
          </template>
        </ul>
      </div>
      <div v-if="showList(version.patches)">
        <p><strong>Patches</strong></p>
        <ul>
          <template v-for="(change, c) in version.patches">
            <li :key="c" v-if="!change.internal || isAdminOrBeta">
              {{ change.message }}
              <span v-if="change.internal">(internal)</span>
            </li>
          </template>
        </ul>
      </div>
      <div
        v-if="
          !showList(version.features) && !showList(version.removals) && !showList(version.patches)
        "
      >
        <ul>
          <li>Miscellaneous fixes and updates</li>
        </ul>
      </div>
      <hr />
    </div> -->
  </div>
</template>

<script>
// import changelog from "@/versions";
// import { computed } from "@vue/composition-api";
// import { dateFormat } from "leatherman-js/utils/formatters/time";
// import store from "@/store";

// const pendingChanges = require("@/changesPending.json");
// const changelog = require("@/versions.json");

export default {
  name: "ChangelogPage",
  setup() {
    // const processEnv = process.env;

    // let parsedChangelog = changelog.versions.map((version) => {
    //   return {
    //     patches: version.changes.filter((c) => c.type === "patch"),
    //     features: version.changes.filter((c) => c.type === "feature"),
    //     removals: version.changes.filter((c) => c.type === "removal"),
    //     semver: version.semver,
    //   };
    // });

    // parsedChangelog.sort((b, a) => {
    //   const a1 = a.semver.split(".");
    //   const b1 = b.semver.split(".");
    //   const len = Math.max(a1.length, b1.length);

    //   for (let i = 0; i < len; i++) {
    //     const _a = +a1[i] || 0;
    //     const _b = +b1[i] || 0;
    //     if (_a === _b) continue;
    //     else return _a > _b ? 1 : -1;
    //   }
    //   return 0;
    // });

    // const isAdminOrBeta = computed(
    //   () => store.getters["auth/isAdminOrBeta"] || processEnv.VUE_APP_DEV_ADMIN
    // );

    // // return false if list is empty
    // // return false if user is not admin/beta and there are only internal changes
    // const showList = (array) => {
    //   if (!array.length) {
    //     return false;
    //   }

    //   if (isAdminOrBeta.value) {
    //     return true;
    //   }

    //   const nonInternal = array.filter((a) => !a.internal);

    //   // console.log({ nonInternal });

    //   return nonInternal.length;
    // };

    return {
      // changelog,
      // parsedChangelog,
      // dateFormat,
      // processEnv,
      // isAdminOrBeta,
      // showList,
      // pendingChanges,
    };
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-weight: bold;
  margin-bottom: 1rem;
}
</style>
